import useAxios from "./useAxios"
import Constants from "../Constants"

const useFileOpener = () => {
    const { postData } = useAxios()

    const openFileInNewTab = async (file) => {
        if (file instanceof File || file instanceof Blob) {
            window.open(URL.createObjectURL(file), '_blank')
        } else {
            const path = typeof file === 'string' ? file : file?.s3UrlPath
            const response = await postData(Constants.ApiUrl.utils.getSignedUrl, { path })
            const signedUrl = response?.data?.signedUrl
            signedUrl && window.open(signedUrl, '_blank')
        }
    }

    return { openFileInNewTab }
}

export default useFileOpener
